export default {
  global: {
    canteenList: [],
    eateryList: []
  },
  userinfo: {
    api_key: '',
    username: '',
    eatery_id: '',
    phoneNum: 0
  },
  fullscreenLoading: false,
  canteenList: [],
  faceCanteenList: []
}
